/** How many reads one `getQualityReadsAction` call may carry; the client splits a larger wave. */
export const MAX_QUALITY_READS = 24
